export default {"src":"/_next/static/media/IDR.95200eae.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};